import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { PendingSignaturesPanelRoutingModule } from './pending-signatures-panel.routing';
import { PendingSignaturesPanelComponent } from './pages/pending-signatures-panel/pending-signatures-panel.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PendingSignaturesPanelRoutingModule,
    SharedModule,
    NgxLoadingModule
  ],
  declarations: [PendingSignaturesPanelComponent]
})
export class PendingSignaturesPanelModule {}
